import { MutationOptions, useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import { TApiProjectSection, TApiSession } from "../../api-client/types"
import { cloneDeep } from "lodash"

interface Args {
  projectId: string
  projectSectionId: string
  position?: number
  name?: string
  status?: TApiProjectSection['status']
}

export const useUpdateProjectSectionMutation = (options?: MutationOptions<any,any,any>) => {
  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  const mutation = useMutation(
    ["update-project-section"],
    async (args: Args) => {
      const response = await apiClient.updateProjectSection(args)

      if (!response.ok) {
        throw response.errors
      }

      return response
    },
    {
      ...options,
      onMutate: (args) => {
        let prevProjectSection: TApiProjectSection

        queryClient.setQueriesData(['project-sections'], (data: any) => {
          if (!data || !data.projectSections) {
            console.error('No data found for project-sections', data)
            return data
          }
      
          const projectSections = data.projectSections as TApiProjectSection[]
          const updatedProjectSections = projectSections.map((ps) => {
            // Update the project section by given arguments

            if (ps.id === args.projectSectionId) { 
              prevProjectSection = ps
              return {...ps, ...args }
            } else {
              return ps
            }
          })
      
          console.error('On mutate - updated sections:', updatedProjectSections)
      
          return { projectSections: updatedProjectSections }
        })

        return {
          prevProjectSection
        }
      },
        /*
        queryClient.getQueriesData(['project-sections']).forEach(([key, data]) => {
          const projectSections = data.projectSections as unknown as TApiProjectSection[]

          let queryProjectSection = projectSections.find((ps) => ps.id == args.projectSectionId)

          console.error('dupa!!')

          if (queryProjectSection) {
            queryProjectSection = {
              ...queryProjectSection,
              name: 'dupa'
            }

            return {
              oldProjectSection: queryProjectSection
            }
          }
        })
        */

      onError: (error, args, context: any) => {
        const prevProjectSection = context.prevProjectSection as TApiProjectSection

        queryClient.setQueriesData(['project-sections'], (data: any) => {
          if (!data || !data.projectSections) {
            console.error('No data found for project-sections', data)
            return data
          }
      
          const projectSections = data.projectSections as TApiProjectSection[]
          const updatedProjectSections = projectSections.map((ps) => {
            // Update the project section by given arguments

            if (ps.id === args.projectSectionId) { 
              return prevProjectSection
            } else {
              return ps
            }
          })
      
          console.error('On error update sections', updatedProjectSections)
      
          return { projectSections: updatedProjectSections }
        })

        if (options.onError) options.onError(error, args, context)
      },

      onSuccess: () => {
        queryClient.invalidateQueries(['project-sections'], { exact: false})
      }
    }
  )

  return mutation
}

export default useUpdateProjectSectionMutation